import axios from "axios"
import { message } from 'ant-design-vue';
import { createStore } from "@/store";
import appConfig from "../../app.config";
const store = createStore();
// 创建axios实例
const service = axios.create({
    baseURL: '/api',
    timeout: 188888000, // 请求超时时间
    headers: {
        'Content-Type': "application/json",
        'Access-Control-Allow-Origin': "*"
    },
    withCredentials: false
});
const serviceSkl = axios.create({
    baseURL: '/sklApi',
    timeout: 188888000, // 请求超时时间
    headers: {
        'Content-Type': "application/json",
        'Access-Control-Allow-Origin': "*"
    },
    withCredentials: false
});
const serviceRmt = axios.create({
    timeout: 188888000, // 请求超时时间
    headers: {
        'Content-Type': "application/x-www-form-urlencoded",
        'Access-Control-Allow-Origin': "*"
    },
    withCredentials: false
});

const serviceIdc = axios.create({
    timeout: 188888000, // 请求超时时间
    headers: {
        'Content-Type': "application/x-www-form-urlencoded"
    },
    withCredentials: false
});

const serviceCloud = axios.create({
    timeout: 188888000, // 请求超时时间
    headers: {
        'Content-Type': "application/json"
    },
    withCredentials: false
});

const serviceQmt = axios.create({
    timeout: 188888000, // 请求超时时间
    headers: {
        'Content-Type': "application/x-www-form-urlencoded",
        'Access-Control-Allow-Origin': "*"
    },
    withCredentials: false
});

//编辑器
const serviceCpc = axios.create({
    timeout: 188888000, // 请求超时时间
    headers: {
        'Content-Type': "application/json",
        'Access-Control-Allow-Origin': "*"
    },
    withCredentials: false
});

//编辑器
const serviceDmpCpc = axios.create({
    timeout: 188888000, // 请求超时时间
    headers: {
        'Content-Type': "application/json",
        'Access-Control-Allow-Origin': "*"
    },
    withCredentials: false
});

serviceDmpCpc.interceptors.request.use(
    config => {
        let baseURL = 'http://dmp2050.test.routeryuncs.com/cpc'
        config.url = baseURL + config.url;

        config.headers["Authorization"] = store.getters.token;

        console.log('serviceCpc', config);
        return config;
    }
)

serviceCpc.interceptors.request.use(
    config => {
        let baseURL = 'http://cpc.api.test.routeryuncs.com'
        config.url = baseURL + config.url;

        config.headers["Authorization"] = store.getters.token;

        console.log('serviceCpc', config);
        return config;
    }
)

serviceQmt.interceptors.request.use(
    config => {
        let baseURL = 'http://dockertest.qmt.routeryun.com'
        config.url = baseURL + config.url;
        console.log('serviceQmt', config);
        return config;
    }
)

serviceCloud.interceptors.request.use(
    config => {
        let baseURL = 'http://cdp-local.test.routeryuncs.com'
        config.url = baseURL + config.url;
        console.log('serviceCloud', config);
        return config;
    }
)

serviceRmt.interceptors.request.use(
    config => {
        let baseURL = 'http://open.fpm.test.routeryuncs.com'
        config.url = baseURL + config.url;
        console.log('serviceRmt', config);
        return config;
    }
)
serviceIdc.interceptors.request.use(
    config => {
        let baseURL = 'http://bigdata.idcapi.test.routeryuncs.com'
        config.url = baseURL + config.url;
        console.log('serviceIdcconfig', config);
        return config;
    }
)
// request拦截器
service.interceptors.request.use(
    config => {
        // let baseURL = 'http://dmp2050-gateway.test.routeryuncs.com'
        // config.url = baseURL + config.url;
        // console.log('config',config);
        config.headers["Authorization"] = store.getters.token;
        // let baseURL = '/api'
        // // let baseURL = 'http://dmp-api.test.routeryuncs.com'

        // config.headers['Content-Type'] = "application/json"
        // if(config.url.indexOf('search-binding-user') !== -1){

        //     // baseURL = 'http://public.open.tmtsp.com'
        //     baseURL = '/rmt'
        //     config.headers['Content-Type'] = "application/x-www-form-urlencoded"
        // }
        // if(config.url.indexOf('authProductUser') !== -1){

        //     // baseURL = 'http://bigdata.idcapi.test.routeryuncs.com'
        //     baseURL = '/bigdata'
        //     config.headers['Content-Type'] = "application/x-www-form-urlencoded"

        // }
        // config.url = baseURL + config.url;

        // config.headers["Authorization"] = "IUAT.eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2MjgwODM3MTcsImlhdCI6MTYyNzQ3ODkxOSwidG9rZW4iOiJlYTVhOGZmN2VjN2ViNzcyOThhMmQ1NWNkN2ZiZjhiNSJ9.St1ODJKSRjZHvH5uQGNB2nsGyWkOD-ITYa7pUtOjkT8"

        return config;
    },
    error => {
        Promise.reject(error);
    }
);

// request拦截器
serviceSkl.interceptors.request.use(
    config => {
        console.log(config);
        // let baseURL = 'http://dmp2050-gateway.test.routeryuncs.com'
        // config.url = baseURL + config.url;
        // console.log('config',config);
        config.headers["Authorization"] = store.getters.token;
        // let baseURL = '/api'
        // // let baseURL = 'http://dmp-api.test.routeryuncs.com'

        // config.headers['Content-Type'] = "application/json"
        // if(config.url.indexOf('search-binding-user') !== -1){

        //     // baseURL = 'http://public.open.tmtsp.com'
        //     baseURL = '/rmt'
        //     config.headers['Content-Type'] = "application/x-www-form-urlencoded"
        // }
        // if(config.url.indexOf('authProductUser') !== -1){

        //     // baseURL = 'http://bigdata.idcapi.test.routeryuncs.com'
        //     baseURL = '/bigdata'
        //     config.headers['Content-Type'] = "application/x-www-form-urlencoded"

        // }
        // config.url = baseURL + config.url;

        // config.headers["Authorization"] = "IUAT.eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2MjgwODM3MTcsImlhdCI6MTYyNzQ3ODkxOSwidG9rZW4iOiJlYTVhOGZmN2VjN2ViNzcyOThhMmQ1NWNkN2ZiZjhiNSJ9.St1ODJKSRjZHvH5uQGNB2nsGyWkOD-ITYa7pUtOjkT8"

        return config;
    },
    error => {
        Promise.reject(error);
    }
);
// respone拦截器
service.interceptors.response.use(
    response => {
        /**
         * response.data是抛错代码 可结合自己业务进行修改
         */
        const res = response.data;
        if (res.httpcode != "200") {
            return response.data;
        } else {
            return response.data;
        }
    },
    error => {
        console.log('错误信息', error)
        console.log('错误信息', error.response)
        if (error.response) {
            if (error.response.status === 401) {
                console.log("登录过期");
                localStorage.removeItem("userinfo");
                localStorage.removeItem("loginInfo");
                localStorage.removeItem("token");
                window.location.href = '/';
                message.error("登陆过期", 3)
                return
            }
        }



        // if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1) {
        //     console.log("接口请求超时！");
        //     message.error("接口请求超时！", 3)
        //     return "";
        // }
        // if (error.response.status === 401) {
        //     console.log("登录过期");
        //     localStorage.removeItem("userinfo");
        //     window.location.href = '/';
        //     message.error("登陆过期", 3)
        //     return

        // } else if (error.response.status === 504) {
        //     console.log("网关错误");
        //     // localStorage.removeItem("userinfo");
        //     // window.location.href = '/';
        //     message.error("网关错误", 3)
        //     return
        // }else if (error.response.status === 405) {
        //     console.log("请绑定老系统账号");
        //     // localStorage.removeItem("userinfo");
        //     // window.location.href = '/';
        //     message.error("请绑定老系统账号", 3)
        //     return
        // }
        // else if (error.response.status === 503 || error.response.status === 502) {
        //     console.log('服务器错误，请联系管理员！');
        //     message.error("服务器错误，请联系管理员！", 3)
        //     return
        // }

        return Promise.reject(error);
    }
);
// respone拦截器
serviceSkl.interceptors.response.use(
    response => {
        /**
         * response.data是抛错代码 可结合自己业务进行修改
         */
        const res = response.data;
        if (res.httpcode != "200") {
            return response.data;
        } else {
            return response.data;
        }
    },
    error => {
        console.log('错误信息', error)
        console.log('错误信息', error.response)

        if (error.response.status === 401) {
            console.log("登录过期");
            localStorage.removeItem("userinfo");
            localStorage.removeItem("loginInfo");
            localStorage.removeItem("token");
            window.location.href = '/';
            message.error("登陆过期", 3)
            return
        }


        // if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1) {
        //     console.log("接口请求超时！");
        //     message.error("接口请求超时！", 3)
        //     return "";
        // }
        // if (error.response.status === 401) {
        //     console.log("登录过期");
        //     localStorage.removeItem("userinfo");
        //     window.location.href = '/';
        //     message.error("登陆过期", 3)
        //     return

        // } else if (error.response.status === 504) {
        //     console.log("网关错误");
        //     // localStorage.removeItem("userinfo");
        //     // window.location.href = '/';
        //     message.error("网关错误", 3)
        //     return
        // }else if (error.response.status === 405) {
        //     console.log("请绑定老系统账号");
        //     // localStorage.removeItem("userinfo");
        //     // window.location.href = '/';
        //     message.error("请绑定老系统账号", 3)
        //     return
        // }
        // else if (error.response.status === 503 || error.response.status === 502) {
        //     console.log('服务器错误，请联系管理员！');
        //     message.error("服务器错误，请联系管理员！", 3)
        //     return
        // }

        return Promise.reject(error);
    }
);

export default [service, serviceRmt, serviceIdc, serviceCloud, serviceQmt, serviceCpc, serviceDmpCpc, serviceSkl];